/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import Form from 'forms/_.extend';

import UnarchiveAccountForm from './UnarchiveAccountForm/UnarchiveAccountForm';
import UnarchiveAccountSuccess from './UnarchiveAccountSuccess/UnarchiveAccountSuccess';
import UnarchiveAccountError from './UnarchiveAccountError/UnarchiveAccountError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class UnarchiveAccount extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const currentAccountDetails: Object = this.props.currentAccountDetails;
    const fields: Array<Object> = [
      {
        name: 'unarchiveAccountForm',
        label: t('general:actions.unarchive_account'),
        title: 'Unarchive Account',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.provide_reason'),
            rules: 'required|string',
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { reason }: Object = data.values().unarchiveAccountForm;

        actionDrawerStore.unarchiveAccount(currentAccountDetails.id, {
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'Unarchive Account',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { currentAccountDetails, actionDrawerStore }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.unarchive_trading_account')} />
          <UnarchiveAccountError currentAccountDetails={currentAccountDetails} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.unarchive_trading_account')} />
          <UnarchiveAccountSuccess currentAccountDetails={currentAccountDetails} />
        </div>
      );
    }

    return (
      <div className={`${styles['action-drawer-form']}`}>
        <ActionDrawerHeader title={t('general:actions.unarchive_trading_account')} />
        <UnarchiveAccountForm
          currentAccountDetails={currentAccountDetails}
          form={this.createForm()}
        />
      </div>
    );
  }
}
